let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}


if (window.subscribeQueue?.length) {
  window.subscribeQueue.forEach((obj) => {
    const { eventName, callback } = obj;
    subscribe(PUB_SUB_EVENTS[eventName], callback);
  });
  window.subscribeQueue = [];
}

if(window.publishQueue?.length) {
  window.publishQueue.forEach((obj) => {
    const { eventName, data } = obj;
    publish(PUB_SUB_EVENTS[eventName], data);
  });
  window.publishQueue = [];
}